import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCoverImages, setImages } from '../redux/slice/sketchSlice';
import { setActiveBookId, setFetchingImages } from '../redux/slice/stepSlice';
import { markStepAsVisited } from '../redux/slice/profileSlice';
import { fetchBatchImagesByBookId } from '../services/mediaService';
import { saveStep } from '../services/stepService';

/**
 * Open one of the customer's books in the builder, at the cover photo step —
 * what tapping a book on My Books does. Shared with the gift page, which
 * reopens gift books the same way.
 */
export default function useOpenBook() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { session } = useSelector((state) => state.authProvider);

  return useCallback(
    (bookId) => {
      window.stop();
      dispatch(setFetchingImages(true));

      fetchBatchImagesByBookId(bookId)
        .then((batchImageRes) => {
          if (!!batchImageRes?.docs?.data?.length) {
            dispatch(setCoverImages(batchImageRes.docs.data.filter((image) => !!image.isCover)));
            dispatch(setImages(batchImageRes.docs.data.filter((image) => !image.isCover)));
          }
        })
        .finally(() => {
          dispatch(setFetchingImages(false));
        });

      saveStep({
        userId: session?.user?._id,
        bookId,
        isCompleted: 'yes',
        stepCode: 'Upload_Your_Cover_Photo',
      });
      dispatch(markStepAsVisited({ id: bookId, currentStepCode: 'Upload_Your_Cover_Photo' }));

      dispatch(setActiveBookId({ bookId }));
      navigate('/dashboard?stepCode=Upload_Your_Cover_Photo');
    },
    [dispatch, navigate, session?.user?._id]
  );
}
